import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router'
import { AuthProvider } from '../context/auth.context.jsx'
import ErrorBoundary from './components/errorBoundary.jsx'
import { applyTheme, getThemePreference } from './utils/theme.js'
import { initI18n } from './i18n'
import { initNativeShell } from './utils/nativeShell'
import { initNativePush } from './utils/nativePush'
import { dismissBootSplash } from './utils/bootSplash'
import { registerServiceWorkerOnWeb } from './utils/registerServiceWorker'
// Side-effect import: the listener has to exist before Chrome fires
// beforeinstallprompt, which it does well before /install can mount.
import './utils/installPrompt'

applyTheme(getThemePreference())
window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
  if (getThemePreference() === 'system') applyTheme('system')
})

initI18n().then(() => {
  createRoot(document.getElementById('root')).render(
    <StrictMode>
      <ErrorBoundary>
      <BrowserRouter>
      <AuthProvider>
        <App/>
        </AuthProvider>
      </BrowserRouter>
      </ErrorBoundary>
    </StrictMode>,
  )
  dismissBootSplash()
  initNativeShell()
  initNativePush()
  registerServiceWorkerOnWeb()
})
